/* Scroll-driven timeline (mm-journey) and before/after results card (mm-proof). */
(function () {
  if (window.__mmMotion) return;
  window.__mmMotion = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var DESKTOP = 1024;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ================= Journey ================= */
  function Journey(el) {
    this.el = el;
    this.scroll = $('[data-mm-jr-scroll]', el);
    this.grid = $('[data-mm-jr-grid]', el);
    this.list = $('[data-mm-jr-list]', el);
    this.rail = $('[data-mm-jr-rail]', el);
    this.track = $('[data-mm-jr-track]', el);
    this.fill = $('[data-mm-jr-fill]', el);
    this.visual = $('[data-mm-jr-visual]', el);
    this.stages = $$('[data-mm-jr-stage]', el);
    this.contents = this.stages.map(function (s) { return $('[data-mm-jr-content]', s); });
    this.images = $$('[data-mm-jr-img]', el);
    this.active = -1;
    this.timers = [];
    this.mode = null;
    var self = this;
    this.stages.forEach(function (s, i) {
      $('[data-mm-jr-toggle]', s).addEventListener('click', function () { self.onClick(i); });
    });
    this.onScroll = function () {
      if (self.ticking) return;
      self.ticking = true;
      requestAnimationFrame(function () { self.ticking = false; self.update(); });
    };
    this.onResize = function () {
      clearTimeout(self.resizeTimer);
      self.resizeTimer = setTimeout(function () { self.setup(); }, 150);
    };
    window.addEventListener('resize', this.onResize);
    this.setup();
  }

  Journey.prototype.cacheHeights = function () {
    this.heights = this.contents.map(function (c) {
      var prev = c.style.maxHeight;
      c.style.maxHeight = 'none';
      var h = c.scrollHeight;
      c.style.maxHeight = prev;
      return h;
    });
  };

  Journey.prototype.setup = function () {
    var mode = window.innerWidth >= DESKTOP && !reduced ? 'scroll' : 'click';
    this.teardown();
    this.mode = mode;
    this.cacheHeights();
    this.active = -1;
    this.open(0, true);
    if (mode === 'scroll') {
      var vh = window.innerHeight;
      var gridH = this.grid.offsetHeight;
      this.scroll.style.minHeight = (vh * 0.6 * this.stages.length + vh) + 'px';
      this.stickyTop = Math.max(0, (vh - gridH) / 2);
      this.useTransform = this.hasClippingAncestor();
      if (!this.useTransform) {
        this.grid.style.position = 'sticky';
        this.grid.style.top = this.stickyTop + 'px';
      }
      this.fill.style.transition = 'none';
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.update();
    } else {
      this.animateFill(0);
      this.staggerBenefits(0);
    }
  };

  Journey.prototype.teardown = function () {
    window.removeEventListener('scroll', this.onScroll);
    this.timers.forEach(clearTimeout);
    this.timers = [];
    this.scroll.style.minHeight = '';
    this.grid.style.position = '';
    this.grid.style.top = '';
    this.grid.style.transform = '';
    this.fill.style.transition = '';
  };

  // position: sticky silently fails under an overflow:hidden/auto ancestor, so fall back to transforms
  Journey.prototype.hasClippingAncestor = function () {
    var node = this.grid.parentElement;
    while (node && node !== document.body) {
      var o = getComputedStyle(node).overflowY;
      if (o === 'hidden' || o === 'auto' || o === 'scroll') return true;
      node = node.parentElement;
    }
    return false;
  };

  Journey.prototype.dotY = function (i) {
    var s = this.stages[i], d = $('[data-mm-jr-dot]', s);
    return s.offsetTop + d.offsetTop + d.offsetHeight / 2 - this.rail.offsetTop;
  };
  Journey.prototype.contentEndY = function (i) {
    var s = this.stages[i], c = this.contents[i];
    return s.offsetTop + c.offsetTop + c.offsetHeight - this.rail.offsetTop;
  };

  Journey.prototype.update = function () {
    var rect = this.scroll.getBoundingClientRect();
    var vh = window.innerHeight;
    var total = Math.max(1, this.scroll.offsetHeight - vh);
    var progress = Math.min(1, Math.max(0, -rect.top / total));
    if (this.useTransform) {
      var maxShift = this.scroll.offsetHeight - this.grid.offsetHeight;
      var shift = Math.min(maxShift, Math.max(0, this.stickyTop - rect.top));
      this.grid.style.transform = 'translateY(' + shift + 'px)';
    }
    var n = this.stages.length;
    var sp = progress * n;
    var idx = Math.min(Math.floor(sp), n - 1);
    var local = sp - idx;
    if (idx !== this.active) this.open(idx);
    var top = this.dotY(idx);
    var end = this.targetEnd(idx);
    this.fill.style.top = top + 'px';
    this.fill.style.height = Math.max(0, local * (end - top)) + 'px';
    this.updateBenefits();
  };

  // content end measured against the final (open) height, not the one mid-animation
  Journey.prototype.targetEnd = function (i) {
    var s = this.stages[i], c = this.contents[i];
    return s.offsetTop + c.offsetTop + this.heights[i] - this.rail.offsetTop;
  };

  Journey.prototype.updateBenefits = function () {
    var fillBottom = this.fill.getBoundingClientRect().bottom;
    var stage = this.stages[this.active];
    if (!stage) return;
    $$('[data-mm-jr-benefit]', stage).forEach(function (b) {
      b.classList.toggle('is-lit', fillBottom >= b.getBoundingClientRect().top + 4);
    });
  };

  Journey.prototype.open = function (index, instant) {
    var self = this;
    if (index === this.active) return;
    var first = this.stages.map(function (s) { return s.getBoundingClientRect().top; });
    this.stages.forEach(function (s, i) {
      if (s._flip) { s._flip.cancel(); s._flip = null; }
      $$('[data-mm-jr-benefit]', s).forEach(function (b) { b.classList.remove('is-lit'); });
      var on = i === index;
      s.classList.toggle('is-active', on);
      self.contents[i].style.maxHeight = on ? self.heights[i] + 'px' : '0px';
      var t = $('[data-mm-jr-toggle]', s);
      if (t) t.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
    this.active = index;
    this.setVisual(index);
    this.sizeTrack();
    if (instant || reduced || !this.stages[0].animate) return;
    this.stages.forEach(function (s, i) {
      var dy = first[i] - s.getBoundingClientRect().top;
      if (Math.abs(dy) < 0.5) return;
      s._flip = s.animate([{ transform: 'translateY(' + dy + 'px)' }, { transform: 'translateY(0)' }], { duration: 500, easing: 'ease-out' });
    });
    var c = this.contents[index];
    c.animate([{ clipPath: 'inset(0 0 100% 0)' }, { clipPath: 'inset(0 0 0% 0)' }], { duration: 500, easing: 'ease-out' });
  };

  Journey.prototype.sizeTrack = function () {
    var last = this.stages[this.stages.length - 1];
    var lastContent = this.contents[this.contents.length - 1];
    var openH = last.classList.contains('is-active') ? this.heights[this.heights.length - 1] : 0;
    var bottom = last.offsetTop + lastContent.offsetTop + openH - this.rail.offsetTop + 36;
    this.track.style.height = bottom + 'px';
  };

  Journey.prototype.setVisual = function (index) {
    if (this.visual) this.visual.setAttribute('data-stage', String(index % 4));
    var hasImg = false;
    this.images.forEach(function (img) {
      var on = parseInt(img.getAttribute('data-mm-jr-img'), 10) === index;
      img.classList.toggle('is-on', on);
      if (on) hasImg = true;
    });
    if (this.visual) this.visual.classList.toggle('has-image', hasImg);
  };

  Journey.prototype.animateFill = function (index) {
    var self = this;
    var top = this.dotY(index), end = this.targetEnd(index);
    this.fill.style.transition = 'none';
    this.fill.style.top = top + 'px';
    this.fill.style.height = '0px';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        self.fill.style.transition = 'height 500ms ease-out';
        self.fill.style.height = Math.max(0, end - top) + 'px';
      });
    });
  };

  Journey.prototype.staggerBenefits = function (index) {
    var self = this;
    $$('[data-mm-jr-benefit]', this.stages[index]).forEach(function (b, i) {
      self.timers.push(setTimeout(function () { b.classList.add('is-lit'); }, 200 + i * 150));
    });
  };

  Journey.prototype.onClick = function (index) {
    if (this.mode === 'scroll') {
      var rect = this.scroll.getBoundingClientRect();
      var total = this.scroll.offsetHeight - window.innerHeight;
      var target = window.scrollY + rect.top + ((index + 0.5) / this.stages.length) * total;
      window.scrollTo({ top: target, behavior: 'smooth' });
      return;
    }
    this.timers.forEach(clearTimeout);
    this.timers = [];
    this.active = -1;
    this.open(index);
    this.animateFill(index);
    this.staggerBenefits(index);
  };

  /* ================= Results card ================= */
  function Proof(el) {
    var self = this;
    this.el = el;
    this.slides = $$('[data-mm-ba-slide]', el);
    this.caps = $$('[data-mm-ba-cap]', el);
    this.dots = $$('[data-mm-ba-dot]', el);
    this.current = 0;
    this.busy = false;
    var prev = $('[data-mm-ba-prev]', el), next = $('[data-mm-ba-next]', el);
    if (prev) prev.addEventListener('click', function () { self.go(self.current - 1); });
    if (next) next.addEventListener('click', function () { self.go(self.current + 1); });
    this.dots.forEach(function (d, i) { d.addEventListener('click', function () { self.go(i); }); });

    var track = $('[data-mm-ba-track]', el);
    if (track) {
      var sx = 0, sy = 0, axis = null;
      track.addEventListener('touchstart', function (e) { sx = e.changedTouches[0].clientX; sy = e.changedTouches[0].clientY; axis = null; }, { passive: true });
      track.addEventListener('touchmove', function (e) {
        if (axis) return;
        var dx = Math.abs(e.changedTouches[0].clientX - sx), dy = Math.abs(e.changedTouches[0].clientY - sy);
        if (dx + dy > 30) axis = dx > dy * 2 ? 'x' : 'y';
      }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (axis !== 'x') return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 50) self.go(self.current + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }

    // pause the looping animation while the card is off screen
    if ('IntersectionObserver' in window && track) {
      new IntersectionObserver(function (entries) {
        el.classList.toggle('is-paused', !entries[0].isIntersecting);
      }, { threshold: 0.05 }).observe(track);
    }
    this.entry();
  }

  Proof.prototype.go = function (index) {
    var n = this.slides.length;
    if (this.busy || n < 2) return;
    index = (index + n) % n;
    if (index === this.current) return;
    var self = this;
    this.busy = true;
    this.slides[this.current].classList.remove('is-active');
    this.caps[this.current] && this.caps[this.current].classList.remove('is-active');
    this.slides[index].classList.add('is-active');
    this.caps[index] && this.caps[index].classList.add('is-active');
    this.dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    this.current = index;
    setTimeout(function () { self.busy = false; }, 650);
  };

  Proof.prototype.entry = function () {
    var cards = $$('[data-mm-proof-card]', this.el);
    if (window.innerWidth < 1280 || reduced || !cards.length || !cards[0].animate) return;
    var done = false;
    var show = function () {
      if (done) return;
      done = true;
      cards.forEach(function (c, i) {
        c.animate([{ opacity: 0, transform: 'translateY(40px)' }, { opacity: 1, transform: 'translateY(0)' }],
          { duration: 800, delay: i * 50, easing: 'linear', fill: 'forwards' });
      });
    };
    cards.forEach(function (c) { c.style.opacity = '0'; c.style.transform = 'translateY(40px)'; });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { show(); io.disconnect(); } });
      }, { threshold: 0.05 });
      io.observe(this.el);
    }
    setTimeout(show, 3000);
  };

  function init(root) {
    $$('[data-mm-jr]', root || document).forEach(function (el) {
      if (el._mmJourney) return;
      el._mmJourney = new Journey(el);
    });
    $$('[data-mm-proof]', root || document).forEach(function (el) {
      if (el._mmProof) return;
      el._mmProof = new Proof(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  // fonts and images change heights after first layout
  window.addEventListener('load', function () {
    $$('[data-mm-jr]').forEach(function (el) { if (el._mmJourney) el._mmJourney.setup(); });
  });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();